module.exports = __webpack_public_path__ + "fonts/SamsungOne-500_v1.1.ee0b81bc.ttf";